import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { io } from "socket.io-client";
import Logo from "../assets/Images/Logo-white.png";
import Select from "react-select";
import toast, { Toaster } from "react-hot-toast";

// Serve Icon Component
const ServeIcon = ({ isServing }) => {
  const fillColor = isServing ? "#72B900" : "#E0E0E0";

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20.5" cy="20.5" r="20.5" fill={fillColor} />
      <path
        d="M14.0117 23.1974C15.5013 23.1974 16.7089 21.9898 16.7089 20.5002C16.7089 19.0106 15.5013 17.803 14.0117 17.803C12.522 17.803 11.3145 19.0106 11.3145 20.5002C11.3145 21.9898 12.522 23.1974 14.0117 23.1974Z"
        fill="white"
      />
      <path
        d="M23.0478 11.9189C23.0478 13.4094 21.9234 14.6161 20.5337 14.6161C19.144 14.6161 18.0195 13.4094 18.0195 11.9189C18.0195 10.4283 19.144 9.22168 20.5337 9.22168C21.9234 9.22168 23.0478 10.4283 23.0478 11.9189Z"
        fill="white"
      />
      <path
        d="M10.7874 11.3622C10.2495 12.7519 8.9233 13.5327 7.82499 13.1068C6.72669 12.6809 6.27466 11.209 6.81261 9.81934C7.35055 8.42964 8.67674 7.64887 9.77505 8.07475C10.8734 8.50062 11.3254 9.9725 10.7874 11.3622Z"
        fill="white"
      />
      <path
        d="M4.0293 23.1974C4.80918 23.1974 5.4414 21.9898 5.4414 20.5002C5.4414 19.0106 4.80918 17.803 4.0293 17.803C3.24941 17.803 2.61719 19.0106 2.61719 20.5002C2.61719 21.9898 3.24941 23.1974 4.0293 23.1974Z"
        fill="white"
      />
      <path
        d="M27.0566 23.1974C28.5462 23.1974 29.7538 21.9898 29.7538 20.5002C29.7538 19.0106 28.5462 17.803 27.0566 17.803C25.567 17.803 24.3594 19.0106 24.3594 20.5002C24.3594 21.9898 25.567 23.1974 27.0566 23.1974Z"
        fill="white"
      />
      <path
        d="M30.2804 11.3622C30.8183 12.7519 32.1445 13.5327 33.2428 13.1068C34.3411 12.6809 34.7932 11.209 34.2552 9.81934C33.7173 8.42964 32.3911 7.64887 31.2928 8.07475C30.1945 8.50062 29.7424 9.9725 30.2804 11.3622Z"
        fill="white"
      />
      <path
        d="M37.0381 23.1974C37.818 23.1974 38.4502 21.9898 38.4502 20.5002C38.4502 19.0106 37.818 17.803 37.0381 17.803C36.2582 17.803 35.626 19.0106 35.626 20.5002C35.626 21.9898 36.2582 23.1974 37.0381 23.1974Z"
        fill="white"
      />
      <path
        d="M20.5341 5.44116C22.0237 5.44116 23.2313 4.80894 23.2313 4.02905C23.2313 3.24917 22.0237 2.61694 20.5341 2.61694C19.0445 2.61694 17.8369 3.24917 17.8369 4.02905C17.8369 4.80894 19.0445 5.44116 20.5341 5.44116Z"
        fill="white"
      />
      <path
        d="M23.0478 29.0773C23.0478 27.5868 21.9234 26.3801 20.5337 26.3801C19.144 26.3801 18.0195 27.5868 18.0195 29.0773C18.0195 30.5679 19.144 31.7745 20.5337 31.7745C21.9234 31.7745 23.0478 30.5679 23.0478 29.0773Z"
        fill="white"
      />
      <path
        d="M10.7874 29.6377C10.2495 28.248 8.9233 27.4672 7.82499 27.8931C6.72669 28.319 6.27466 29.7909 6.81261 31.1806C7.35055 32.5703 8.67674 33.351 9.77505 32.9251C10.8734 32.4993 11.3254 31.0274 10.7874 29.6377Z"
        fill="white"
      />
      <path
        d="M30.2804 29.6377C30.8183 28.248 32.1445 27.4672 33.2428 27.8931C34.3411 28.319 34.7932 29.7909 34.2552 31.1806C33.7173 32.5703 32.3911 33.351 31.2928 32.9251C30.1945 32.4993 29.7424 31.0274 30.2804 29.6377Z"
        fill="white"
      />
      <path
        d="M20.5341 38.3831C22.0237 38.3831 23.2313 37.7508 23.2313 36.9709C23.2313 36.1911 22.0237 35.5588 20.5341 35.5588C19.0445 35.5588 17.8369 36.1911 17.8369 36.9709C17.8369 37.7508 19.0445 38.3831 20.5341 38.3831Z"
        fill="white"
      />
    </svg>
  );
};

const Home = () => {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeMatch, setActiveMatch] = useState(null);
  const [socket, setSocket] = useState(null);
  const navigate = useNavigate();
  const { categoryId } = useParams();

  // Socket.IO connection
  useEffect(() => {
    const newSocket = io(
      "https://live-score-backend-474085555937.asia-south1.run.app",
      {
        transports: ["websocket", "polling"],
        timeout: 20000,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        maxReconnectionAttempts: 10,
        forceNew: true,
      }
    );

    // Connection event handlers
    newSocket.on("connect", () => {
      console.log("✅ WebSocket connected successfully");
      // Join live score room for general updates
      newSocket.emit("joinLiveScore");
    });

    newSocket.on("disconnect", (reason) => {
      console.log("❌ WebSocket disconnected:", reason);
    });

    newSocket.on("connect_error", (error) => {
      console.error("❌ WebSocket connection error:", error);
    });

    newSocket.on("reconnect", (attemptNumber) => {
      console.log("🔄 WebSocket reconnected after", attemptNumber, "attempts");
      // Re-join live score room after reconnection
      newSocket.emit("joinLiveScore");
    });

    newSocket.on("reconnect_error", (error) => {
      console.error("❌ WebSocket reconnection error:", error);
    });

    newSocket.on("reconnect_failed", () => {
      console.error("❌ WebSocket reconnection failed");
    });

    setSocket(newSocket);

    // Set up periodic heartbeat to keep connection alive
    const heartbeatInterval = setInterval(() => {
      if (newSocket.connected) {
        newSocket.emit("ping");
      }
    }, 30000); // Send ping every 30 seconds

    return () => {
      clearInterval(heartbeatInterval);
      newSocket.close();
    };
  }, []);

  // Fetch matches on component mount or when category changes
  useEffect(() => {
    fetchMatches();
  }, [categoryId]);

  // Handle Socket.IO messages
  useEffect(() => {
    if (!socket) return;

    socket.on("scoreUpdate", () => {
      fetchMatches();
    });

    socket.on("setEnd", () => {
      fetchMatches();
    });

    socket.on("serveUpdate", () => {
      fetchMatches();
    });

    socket.on("matchEnd", () => {
      fetchMatches();
    });

    socket.on("activeMatchChange", () => {
      fetchMatches();
    });

    socket.on("courtCleared", () => {
      fetchMatches();
    });

    socket.on("undoScore", () => {
      fetchMatches();
    });

    return () => {
      socket.off("scoreUpdate");
      socket.off("setEnd");
      socket.off("serveUpdate");
      socket.off("matchEnd");
      socket.off("activeMatchChange");
      socket.off("courtCleared");
      socket.off("undoScore");
    };
  }, [socket]);

  const fetchMatches = async () => {
    try {
      let response;

      if (categoryId) {
        // Fetch matches by category
        response = await axios.get(
          `https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/matches/category/${encodeURIComponent(
            categoryId
          )}`
        );
      } else {
        // Fetch all matches
        response = await axios.get(
          "https://api-third-shot-score-684526581556.asia-south1.run.app/pickleball/matches"
        );
      }

      if (response.data.success) {
        // Sort matches: active matches first, then completed matches
        const sortedMatches = response.data.data.sort((a, b) => {
          // Active matches come first
          if (a.status === "active" && b.status !== "active") return -1;
          if (a.status !== "active" && b.status === "active") return 1;

          // If both are active or both are completed, sort by matchId (newest first)
          return b.matchId - a.matchId;
        });

        setMatches(sortedMatches);
        // Find active match
        const active = sortedMatches.find((match) => match.status === "active");
        setActiveMatch(active);
      }
    } catch (error) {
      console.error("Error fetching matches:", error);
    } finally {
      setLoading(false);
    }
  };

  const getSetScore = (sets, setNumber, team) => {
    const set = sets.find((s) => s.setNumber === setNumber);
    if (!set) return "";

    if (team === "A") {
      return set.teamAScore.toString();
    } else {
      return set.teamBScore.toString();
    }
  };

  const shouldShowSet = (match, setNumber) => {
    // For active matches, only show current set and past sets
    // Don't show future sets (display as 0)
    console.log(setNumber <= match.currentSet);
    // Show set if it's current or past set, OR if any team has scored in this set
    const set = match.sets.find((s) => s.setNumber === setNumber);
    const hasScore = set && (set.teamAScore > 0 || set.teamBScore > 0);

    // For active matches, always show the current set even if no one has scored yet
    if (match.status === "active" && setNumber === match.currentSet) {
      return true;
    }

    // For completed matches or past sets, only show if there's a score
    if (match.status !== "active") {
      return setNumber <= match.currentSet && hasScore;
    } else {
      return setNumber <= match.currentSet && hasScore;
    }
  };

  const getTotalSets = (sets, team, teamA, teamB) => {
    return sets.filter((set) => set.winner === (team === "A" ? teamA : teamB))
      .length;
  };

  const isSetWinner = (sets, setNumber, teamName) => {
    const set = sets.find((s) => s.setNumber === setNumber);
    return set && set.winner === teamName;
  };

  const getMatchWinner = (match) => {
    const teamASets = getTotalSets(match.sets, "A", match.teamA, match.teamB);
    const teamBSets = getTotalSets(match.sets, "B", match.teamA, match.teamB);

    if (teamASets > teamBSets) return match.teamA;
    if (teamBSets > teamASets) return match.teamB;
    return null;
  };

  const handleCardClick = (match) => {
    if (match.status === "active") {
      navigate(`/live-match/${match.matchId}`);
    } else {
      navigate(`/controller`);
    }
  };

  const getCourtUrl = (court) => {
    return `/court/${court}`;
  };

  if (loading) {
    return (
      <div
        className="min-h-screen"
        style={{
          background:
            "linear-gradient(99.32deg, #67008B -0.41%, #BC30EF 93.61%)",
        }}
      >
        <div className="flex items-center justify-center h-screen">
          <div className="text-white text-xl">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div
        style={{
          background:
            "linear-gradient(99.32deg, rgb(1 30 72) -0.41%, rgb(17 64 132) 93.61%)",
        }}
        className="text-white p-6 pb-8"
      >
        {categoryId && (
          <button
            onClick={() => navigate("/")}
            className="absolute top-2 right-2 bg-white text-gray-800 p-2.5 rounded-full transition-all duration-200 hover:bg-gray-100 hover:scale-105 shadow-md hover:shadow-lg"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        )}
        <h1 className="text-2xl font-bold text-center mb-3 mt-8">
          {categoryId ? `${categoryId} - Live Score` : "Live Score"}
        </h1>
        {!categoryId && (
          <div className="text-center mb-4">
            <button
              onClick={() => navigate("/")}
              className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg transition-all"
            >
              View All Categories
            </button>
          </div>
        )}
        <p className="text-center text-sm opacity-90 mb-3 mt-4">Powered by</p>
        <div className="flex justify-center mb-8">
          <img src={Logo} alt="PLLAYER" className="h-8" />
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-md mx-auto">
        {/* Match List */}
        <div className="space-y-3 p-4">
          {matches.length === 0 ? (
            <div className="p-8 text-center text-gray-500">
              <p>No matches found</p>
            </div>
          ) : (
            matches.map((match) => {
              const matchWinner = getMatchWinner(match);
              const teamASets = getTotalSets(
                match.sets,
                "A",
                match.teamA,
                match.teamB
              );
              const teamBSets = getTotalSets(
                match.sets,
                "B",
                match.teamA,
                match.teamB
              );

              return (
                <div
                  key={match.matchId}
                  // onClick={() => handleCardClick(match)}
                  className={`bg-white rounded-lg shadow-md p-4 cursor-pointer transition-all hover:shadow-lg ${
                    match.status === "active" ? "border-2 border-red-400" : ""
                  }`}
                >
                  {/* Score Table Layout */}
                  <div
                    className={`grid gap-2 mb-4 ${
                      shouldShowSet(match, 3)
                        ? "grid-cols-[1fr_50px_50px_50px_50px]"
                        : shouldShowSet(match, 2)
                        ? "grid-cols-[1fr_50px_50px_50px]"
                        : shouldShowSet(match, 1)
                        ? "grid-cols-[1fr_50px_50px]"
                        : "grid-cols-[1fr_50px]"
                    }`}
                  >
                    {/* Column Headers */}
                    <div className="text-xs text-gray-500 font-medium text-left">
                      {" "}
                      <div className="bg-black text-white text-xs px-3 py-1 w-fit rounded">
                        Match :{" "}
                        {match.categoryMatchId
                          ? match.categoryMatchId.toString().padStart(2, "0")
                          : match.matchId.toString().padStart(2, "0")}
                      </div>
                    </div>
                    <div className="text-xs text-gray-500 font-medium text-center  w-[40px]">
                      Sets
                    </div>
                    {shouldShowSet(match, 1) && (
                      <div className="text-xs text-gray-500 font-medium text-center  w-[40px]">
                        1
                      </div>
                    )}
                    {shouldShowSet(match, 2) && (
                      <div className="text-xs text-gray-500 font-medium text-center  w-[40px]">
                        2
                      </div>
                    )}
                    {shouldShowSet(match, 3) && (
                      <div className="text-xs text-gray-500 font-medium text-center  w-[40px]">
                        3
                      </div>
                    )}
                    {/* Empty column for spacing */}
                    {/* Player A Row */}
                    <div className="text-sm flex items-center font-medium text-gray-800 truncate">
                      <div className="flex items-center gap-2 text-wrap">
                        <ServeIcon isServing={match.teamAServe} />
                        {match.teamA}
                      </div>
                    </div>
                    <div
                      className={`text-sm font-normal p-2 rounded text-center h-[40px] w-[40px] ${
                        teamASets > teamBSets
                          ? "bg-[#922ABF] text-white"
                          : "bg-[#fdf4ff] text-gray-800 border border-[#922ABF]"
                      }`}
                    >
                      {teamASets}
                    </div>
                    {shouldShowSet(match, 1) && (
                      <div
                        className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                          isSetWinner(match.sets, 1, match.teamA)
                            ? "bg-[#922ABF] text-white"
                            : "bg-[#F2F2F2] text-gray-800"
                        }`}
                      >
                        {shouldShowSet(match, 1)
                          ? getSetScore(match.sets, 1, "A")
                          : "0"}
                      </div>
                    )}
                    {shouldShowSet(match, 2) && (
                      <div
                        className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                          isSetWinner(match.sets, 2, match.teamA)
                            ? "bg-[#922ABF] text-white"
                            : "bg-[#F2F2F2] text-gray-800"
                        }`}
                      >
                        {shouldShowSet(match, 2)
                          ? getSetScore(match.sets, 2, "A")
                          : "0"}
                      </div>
                    )}
                    {shouldShowSet(match, 3) && (
                      <div
                        className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                          isSetWinner(match.sets, 3, match.teamA)
                            ? "bg-[#922ABF] text-white"
                            : "bg-[#F2F2F2] text-gray-800"
                        }`}
                      >
                        {shouldShowSet(match, 3)
                          ? getSetScore(match.sets, 3, "A")
                          : "0"}
                      </div>
                    )}

                    {/* VS Row */}
                    <div className="text-xs h-[12px] text-gray-400 font-medium truncate flex items-center">
                      <div className="flex-1 h-px bg-gray-300 mr-2"></div>
                      VS
                      <div className="flex-1 h-px bg-gray-300 ml-2"></div>
                    </div>
                    <div className="h-[12px] flex items-center justify-center">
                      <div className="w-full h-px bg-gray-300"></div>
                    </div>
                    {shouldShowSet(match, 1) && (
                      <div className="h-[12px] flex items-center justify-center">
                        <div className="w-full h-px bg-gray-300"></div>
                      </div>
                    )}
                    {shouldShowSet(match, 2) && (
                      <div className="h-[12px] flex items-center justify-center">
                        <div className="w-full h-px bg-gray-300"></div>
                      </div>
                    )}
                    {shouldShowSet(match, 3) && (
                      <div className="h-[12px] flex items-center justify-center">
                        <div className="w-full h-px bg-gray-300"></div>
                      </div>
                    )}

                    {/* Player B Row */}
                    <div className="text-sm flex items-center font-normal text-gray-800 truncate">
                      <div className="flex items-center gap-2 text-wrap">
                        <ServeIcon isServing={match.teamBServe} />
                        {match.teamB}
                      </div>
                    </div>
                    <div
                      className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                        teamBSets > teamASets
                          ? "bg-[#922ABF] text-white"
                          : "bg-[#fdf4ff] text-gray-800 border border-[#922ABF]"
                      }`}
                    >
                      {teamBSets}
                    </div>
                    {shouldShowSet(match, 1) && (
                      <div
                        className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                          isSetWinner(match.sets, 1, match.teamB)
                            ? "bg-[#922ABF] text-white"
                            : "bg-[#F2F2F2] text-gray-800"
                        }`}
                      >
                        {getSetScore(match.sets, 1, "B")}
                      </div>
                    )}
                    {shouldShowSet(match, 2) && (
                      <div
                        className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                          isSetWinner(match.sets, 2, match.teamB)
                            ? "bg-[#922ABF] text-white"
                            : "bg-[#F2F2F2] text-gray-800"
                        }`}
                      >
                        {getSetScore(match.sets, 2, "B")}
                      </div>
                    )}
                    {shouldShowSet(match, 3) && (
                      <div
                        className={`text-sm font-medium p-2 rounded text-center h-[40px] w-[40px] ${
                          isSetWinner(match.sets, 3, match.teamB)
                            ? "bg-[#922ABF] text-white"
                            : "bg-[#F2F2F2] text-gray-800"
                        }`}
                      >
                        {getSetScore(match.sets, 3, "B")}
                      </div>
                    )}
                  </div>

                  {/* Match Details Footer */}
                  <div className="flex justify-between items-center">
                    <span className="text-[#922ABF] text-xs font-medium">
                      {match.category}
                    </span>
                    {match.status === "active" && (
                      <div className="flex items-center gap-1">
                        <div className="w-2 h-2 bg-red-500 rounded-full"></div>
                        <span className="text-red-500 text-xs font-medium">
                          Live Now
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </div>
  );
};

export default Home;
